// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"b876ae87","213":"dc701bfb","239":"8842cf4e","455":"70342a1e"}[chunkId] + ".chunk.js";
};